// src/views/NewsDetail.vue (或 src/components/NewsDetail.vue)
<template>
  <div class="news-detail-page">
    <HeaderView /> {/* 如果你的页头是全局的或在App.vue中，这里可能不需要 */}
    <div v-if="newsItem">
      <h1>{{ newsItem.title }}</h1>
      <p class="date">发布日期: {{ newsItem.date }}</p>
      <div class="content" v-html="newsItem.fullContent"></div> {/* 假设 fullContent 是 HTML */}
    </div>
    <div v-else>
      <p>正在加载新闻内容，或新闻未找到...</p>
    </div>
    <FooterView2 /> {/* 如果你的页脚是全局的或在App.vue中，这里可能不需要 */}
  </div>
</template>

<script>
// import HeaderView from '@/components/HeaderView.vue'; // 如果需要
// import FooterView2 from '@/components/FooterView2.vue'; // 如果需要

export default {
  name: 'NewsDetail',
  // components: { HeaderView, FooterView2 }, // 如果需要
  props: ['id'], // 接收来自路由的 id 参数
  data() {
    return {
      newsItem: null // 用于存储新闻详情
    };
  },
  created() {
    // 在组件创建时，根据传入的 id 获取新闻数据
    this.fetchNewsDetails();
  },
  watch: {
    // 如果用户在新闻详情页之间通过路由导航 (例如，从相关新闻链接)，
    // id prop 会改变，这时需要重新获取数据
    id() {
      this.fetchNewsDetails();
    }
  },
  methods: {
    fetchNewsDetails() {
      // 这里是模拟数据获取。在实际应用中，你会根据 this.id 从 API 或状态管理中获取数据
      const allNews = [ // 这个数据源应该与 NewsSection.vue 中的或者一个共享的数据源一致
        { id: 'waykar-erp-2-0', title: 'WaykarERP2.0中台架构全球首发...', date: '...', fullContent: '<p>Waykar集团投入千万级研发...</p>' },
        { id: 'caihe-zhan', title: '彩盒展签约火爆 | 印企数智化突围，关键在这两点！', date: '2025-04-11', fullContent: '<p>2025年国际彩盒展圆满落下帷幕...</p>' },
        // ... 其他新闻项，包含 fullContent
      ];
      this.newsItem = allNews.find(news => news.id === this.id) || null;
      if (!this.newsItem) {
        console.error(`未找到 ID 为 "${this.id}" 的新闻。`);
        // 你可以在这里处理未找到新闻的情况，例如导航到404页面
        // this.$router.push({ name: 'NotFound' });
      }
    }
  }
}
</script>

<style scoped>
.news-detail-page {
  padding: 20px;
  /* 添加你的样式 */
}
.date {
  color: #888;
  font-size: 0.9em;
  margin-bottom: 15px;
}
.content {
  line-height: 1.6;
}
</style>